// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__XN00Q","container":"Modal_container__Jra2g"};